<template lang="pug">
el-dialog(
  v-dialogDrag,
  title="选择成员",
  modal-append-to-body,
  append-to-body,
  :fullscreen="fullscreen",
  :close-on-click-modal="false",
  width="800px",
  top="60px",
  :visible.sync="memeberShow",
  @close="closeHandler"
)
  .body
    .nav
      //- 选人菜单
      el-tabs(v-model="memberType", @tab-click="radioClick")
        el-tab-pane(v-for="item in typeList", :key="item.code", :label="item.label", :name="item.code")
    .content
      splitpanes.default-theme(split="horizontal")
        pane(min-size="50", size="60", max-size="60")
          //- 对应的组件
          component.leftNav(ref="leftcom", @updateRight="updateRight", v-bind="$props", :is="typeCom", :userList="userList", :key="keyIndex",:isLowcode='true')
        pane(min-size="40", size="40")
          .rightNav
            //-显示已选的人员
            .checkedTitle(v-if="allSelectList.length")
              el-tooltip(placement="top")
                i.el-icon-warning-outline
                template(#content)
                  p.p-tips 双击下方分类名称: 切换选中状态
                  p.p-tips #[code shift] + 双击: 全部选中
                  p.p-tips #[code ctrl] + 双击: 取消选中
              span 已选 ( {{ allSelectList.length }}/{{ rightCheckList.length }} )
              span.tip(v-if="overMax") 已超出最大可选数量:({{allSelectList.length}}/{{max}})
              i.el-icon-delete.right(title="清空", @click="batchDeleteList")
            el-checkbox-group.checkedList(v-model="rightCheckList")
              .tag-block(v-for="it in showSelectList", :key="it.type")
                input.expand-checkbox(type="checkbox")
                i.arrow-icon.el-icon-arrow-down
                .name(@dblclick="onCheckGroupDbl($event, it)") {{ it.label }}:
                el-dropdown.more(size="mini", @command="groupHandler($event, it)")
                  i.el-icon-more
                  el-dropdown-menu(slot="dropdown")
                    el-dropdown-item(v-for="action in checkAction", :key="action.id", :command="action.id")
                      span {{ action.cnName }}
                      span #[code(v-if="action.key") {{ action.key }}] 双击

                .tag-con
                  //- 人员选择 有专门的显示逻辑
                  UserList(v-if="it.code === 'User'", :list="it.array", @delete="deleteUser($event, it.array)")
                    template(#default="{ nodeId }")
                      el-checkbox.right-checkbox-label(:label="nodeId")
                  template(v-else)
                    label.node-item(v-for="tag in it.array", :key="tag.nodeId") {{ it.tag }}
                      el-checkbox.right-checkbox-label(:label="tag.nodeId")
                      node-icon(:type="it.code")
                        span.select-name {{ tag.selectName }}
                      i.el-icon-delete.delete(@click.prevent.stop="deleteValue(it.array, tag)")
  template(#footer)
    el-button(@click="closeHandler", size="small") 取 消
    el-button(type="primary", @click="onSubmit", size="small") 确 定
</template>

<script>
/**
 * 选人组件：
 * 1.能否选择自己
 * 2.集中选择类型：目前：人员、系统角色、项目角色、专业角色、部门、标签
 * 3.单双选
 * */
import NodeIcon from "@/CommonDP/components/chooseMember/component/NodeIcon.vue";
import { Splitpanes, Pane } from "splitpanes";
import "splitpanes/dist/splitpanes.css";
import { asyncMixin } from "@/CommonDP/commons/asyncCom.js";
import { typeCompontent, ALL_NAV_LIST } from "./leftCom";
import { castArray, cloneDeep, pull } from "lodash-es";
import personInfoService from "@/CommonDP/service/admin/personInfo-service.js";
import UserList from "@/CommonDP/components/userList/index.vue";

function initBtnAuth(array, usersList) {
  const list = cloneDeep(ALL_NAV_LIST);
  const showList = array.length === 0 ? list : list.filter((e) => array.includes(e.code));
  return showList.map((e) => {
    return {
      ...e,
      array: usersList?.filter((user) => user.selectCode === e.code) || []
    };
  });
}
const Check_Action_ENum = {
  all: "all",
  toggle: "toggle",
  clear: "clear"
};
export default {
  components: { Splitpanes, Pane, NodeIcon, UserList },
  mixins: [asyncMixin],
  props: {
    isLowcode: { type: Boolean, default: false },
    type: { type: Number, default: 1 },
    // 是否过滤当前用户 ,默认为false
    filterOneself: { type: Boolean, default: false },
    // 限制人数，可多选单选人员
    max: { type: Number, default: 1000 },
    // 权限列表：ALL_NAV_LIST中code组成的数组
    codePri: { type: Array, default: () => [] },
    // 用户id字符串,仅支持userId,使用,隔开
    userIds: { type: String, default: "" },
    // 人员信息的数组列表：userSelected抛出去的数组
    usersList: { type: Array, default: () => [] },
    // 当前部门
    curDeptId: { type: String, default: "" },
    // 部门
    deptId: { type: String, default: "" },
    // 项目id
    prjId: { type: String, default: "" },
    // 项目角色code
    prjRoleId: { type: String, default: "" },
    // 专业角色code
    specRoleId: { type: String, default: "" },
    // 系统角色code
    sysRoleId: { type: String, default: "" },
    // 标签角色code
    labelRole: { type: String, default: "" },
    // 是否全屏
    fullscreen: { type: Boolean, default: false }
  },
  data() {
    const typeList = initBtnAuth(this.codePri, this.usersList);
    const memberType = typeList[0]?.code || "";
    return {
      memeberShow: false,
      memberType,
      typeList,
      typeCom: "",
      keyIndex: 0,
      checkAction: [
        { id: Check_Action_ENum.toggle, cnName: "反选" },
        { id: Check_Action_ENum.all, cnName: "全选", key: "shift" },
        { id: Check_Action_ENum.clear, cnName: "清空", key: "ctrl" }
      ],
      rightCheckList: []
    };
  },
  computed: {
    // 组件对应的选择
    userList() {
      const list = this.typeList.find((e) => e.code === this.memberType)?.array || [];
      return list;
    },
    // 右侧已选显示
    showSelectList() {
      return this.typeList.filter((e) => e.array.length);
    },
    // 是否超出人员数量
    overMax() {
      return this.max < this.allSelectList.length;
    },
    allSelectList() {
      const array = [];
      for (const iterator of this.typeList) {
        if (iterator.array && iterator.array.length) {
          for (const io of iterator.array) {
            array.push({ ...io, selectCode: iterator.code });
          }
        }
      }
      return array;
    }
  },
  async mounted() {
    this.radioClick(this.memberType);
    await this.getServeUserById();
    this.memeberShow = true;
  },
  methods: {
    onCheckGroupDbl(e, group) {
      const actionName = e.ctrlKey ? Check_Action_ENum.clear : e.shiftKey ? Check_Action_ENum.all : Check_Action_ENum.toggle;
      this.groupHandler(actionName, group);
    },
    groupHandler(actionName, group) {
      const { rightCheckList } = this;
      const idSet = new Set(rightCheckList);
      const groupList = castArray(group);
      for (const { array } of groupList) {
        for (const { nodeId } of array) {
          switch (actionName) {
            case Check_Action_ENum.all:
              idSet.add(nodeId);
              break;
            case Check_Action_ENum.clear:
              idSet.delete(nodeId);
              break;
            case Check_Action_ENum.toggle:
              idSet.has(nodeId) ? idSet.delete(nodeId) : idSet.add(nodeId);
              break;
          }
        }
      }
      this.rightCheckList = [...idSet];
    },
    async getServeUserById() {
      const { userIds } = this;
      const userCode = "User";
      if (!userIds) return;
      const ids = userIds
        .split(",")
        .filter((d) => d)
        .map((id) => id.trim())
        .filter((d) => d);
      if (!ids.length) return;
      const { data } = await personInfoService.batchQueryCommonUserInfo(ids);
      // 腊鸡接口不支持顺序,需要前端排序
      const map = {};
      for (const user of data) {
        map[user.userId] = user;
      }
      // 完善用户展示数据
      const userList = ids.map((id) => {
        const item = map[id];
        return {
          ...item,
          nodeId: item.userId,
          nodeName: item.username,
          code: userCode,
          selectCode: userCode
        };
      });
      const userItem = this.typeList.find(({ code }) => code === userCode);
      if (userItem) {
        userItem.array = userList;
      }
    },
    // 关闭选人组件
    async closeHandler() {
      this.memeberShow = false;
      await window.CefSharp.BindObjectAsync("cefSharpBrower");
      window.cefSharpBrower.closeWindow();
      this.reject();
    },
    // 更新右侧数据
    updateRight(type, list) {
      for (const iterator of this.typeList) {
        if (iterator.code === type) {
          iterator.array = list;
        }
      }
    },
    deleteUser(id, arr) {
      const index = arr.findIndex(({ userId }) => userId === id);
      if (index + 1) {
        this.deleteValue(arr, arr[index]);
      }
    },
    deleteValue(list, item) {
      pull(this.rightCheckList, item.nodeId);
      const index = list.findIndex(({ nodeId }) => item.nodeId === nodeId);
      if (index + 1) {
        const rawItem = list[index];
        list.splice(index, 1);
        this.$refs.leftcom.cancel?.(rawItem);
      }
    },
    async batchDeleteList() {
      const { rightCheckList: selections, typeList } = this;
      if (selections?.length) {
        await this.$confirm("确定清空选择的数据吗?");
        const args = [];
        const idSet = new Set(selections);
        for (const { array } of typeList) {
          for (const item of array) {
            idSet.has(item.nodeId) && args.push([array, item]);
          }
        }
        for (const arg of args) {
          Reflect.apply(this.deleteValue, this, arg);
        }
      } else {
        this.clearList();
      }
    },
    async clearList() {
      await this.$confirm("确定清空全部的数据吗?");
      this.typeList = initBtnAuth(this.codePri);
      this.keyIndex++;
    },
    // 数据提交
    onSubmit() {
      if (this.overMax) {
        return this.$message("超出人员数量");
      } else {
        this.resolve(this.allSelectList);
      }
      this.memeberShow = false;
    },
    // 切换选人的单选按钮
    radioClick() {
      console.log(this.memberType);
      this.typeCom = typeCompontent(this.memberType);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/CommonDP/styles/mixin";
.body {
  height: 500px;
  .content {
    height: calc(100% - 50px);
    padding-top: 10px;
  }
}
.splitpanes__pane {
  padding: 0 5px;
}
.leftNav {
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.rightNav {
  height: 100%;
  background-color: #f8fafe;
  border-radius: 5px;
  padding: 5px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  .checkedTitle {
    height: 40px;
    line-height: 40px;
    padding: 0 4px 0 12px;
    display: flex;
    flex-direction: row;
    align-items: center;
    .el-tooltip {
      color: $--color-primary;
      font-size: 16px;
      margin: 0 4px 0 -8px;
    }
    .tip {
      color: $--color-danger;
      margin-left: 12px;
    }
    .right {
      font-size: 16px;
      margin-left: auto;
      cursor: pointer;
      color: $--color-danger;
    }
  }
  .checkedList {
    flex: 1 1;
    user-select: none;
    overflow-y: auto;
    .right-checkbox-label {
      margin-left: 4px;
      flex: 0 0;
      ::v-deep .el-checkbox__label {
        display: none;
      }
    }
  }
}

.tag-block {
  position: relative;
  line-height: 1;
  margin: 0 0 8px;
  .arrow-icon,
  .expand-checkbox {
    position: absolute;
    left: 4px;
    top: 4px;
  }
  .more {
    position: absolute;
    right: 6px;
    top: 4px;
    cursor: pointer;
  }
  .arrow-icon {
    pointer-events: none;
    padding: 1px;
    border-radius: 2px;
    transition: all 0.2s;
  }
  .expand-checkbox {
    opacity: 0;
    cursor: pointer;
    &:hover ~ .arrow-icon {
      background: $--color-info;
      color: #fff;
    }
    &:checked {
      ~ .tag-con {
        display: none;
      }
      ~ .arrow-icon {
        transform: rotate(-90deg);
      }
    }
  }
  .delete {
    margin: 4px 4px;
    color: $--color-danger;
    cursor: pointer;
    font-size: 16px;
  }
  .tag-con {
    position: relative;
    &::before {
      content: "";
      border-left: 4px solid rgba($--color-primary, 0.1);
      position: absolute;
      left: 8px;
      top: 0;
      bottom: 0;
    }
  }
  .name {
    border-radius: 2px;
    font-size: 12px;
    padding: 4px 20px;
    color: var(--info-color);
    border: 1px dotted transparent;
    &:hover {
      border-color: $--color-primary;
    }
  }
  .select-name {
    font-size: 12px;
  }
  .node-item {
    padding: 4px 0;
    display: flex;
    flex-flow: nowrap row;
    justify-content: space-between;
    align-items: center;
    &:hover {
      background-color: rgba($--color-primary, 0.1);
    }
    .node-icon {
      display: flex;
      flex: 1 1;
      margin: 0 4px;
      align-items: center;
      ::v-deep img {
        width: 20px;
        height: 20px;
        object-fit: scale-down;
        flex-shrink: 0;
      }
    }
  }
}
.p-tips {
  color: #fff;
  margin: 4px 0;
  list-style: disc;
  display: list-item;
  user-select: none;
}
.el-dropdown-menu__item {
  display: flex;
  width: 160px;
  flex-flow: row nowrap;
  justify-content: space-between;
}

code {
  border-radius: 2px;
  padding: 1px 2px;
  font-size: 0.9em;
  background-color: #fff;
  color: #333;
  box-shadow: 0 0 0 1px #bbb, 2px 3px 1px -2px #ddd;
  &:hover {
    background-color: mix(#fff, $--color-primary, 90%);
    color: $--color-primary;
  }
}
</style>
